// Legacy transport retains exact string/numeric values. Metadata stays on local
// arrays, so existing .includes() and form contracts need no type conversion.
export const optionLabel = (list, value) => Object.prototype.hasOwnProperty.call(list?.labels || {}, value) ? list.labels[value] : value;
export function orderedOptions(list = []) {
  return list.configured ? list.slice() : list.slice().sort();
}
function catalogOptions(catalog, includeInactive, aliases = {}) {
  const rows = catalog.options.filter(o => includeInactive || o.active).slice();
  rows.sort(catalog.order === "manual" ? (a, b) => a.position - b.position : (a, b) => a.value < b.value ? -1 : a.value > b.value ? 1 : 0);
  const list = rows.map(o => o.value);
  const labels = Object.fromEntries(catalog.options.map(o => [o.value, o.label]));
  for (const [alias, code] of Object.entries(aliases)) {
    if (!Object.prototype.hasOwnProperty.call(labels, alias) && Object.prototype.hasOwnProperty.call(labels, code)) labels[alias] = labels[code];
  }
  Object.defineProperties(list, {
    configured: { value: true },
    labels: { value: labels },
  });
  return list;
}
export function buildLogisticaAdapters(configuration, displayAliases = {}) {
  const catalogs = Object.fromEntries(Object.entries(configuration.catalogs).map(([key, c]) => [key, catalogOptions(c, false, displayAliases[key])]));
  const fields = Object.fromEntries(Object.entries(configuration.fields).map(([key, f]) => {
    const field = { ...f };
    // Search includes inactive values. Forms expose only active choices and
    // append the current historical value locally in their renderer.
    if (f.catalog) {
      field.dati = catalogOptions(configuration.catalogs[f.catalog], true, displayAliases[f.catalog]);
      (f.extraOptions || []).forEach(o => {
        field.dati.push(o.value);
        field.dati.labels[o.value] = configuration.groups[o.group]?.label || o.desc;
      });
    } else if (f.options) {
      field.dati = f.options.map(o => o.group ? {
        value: configuration.groups[o.group].members.join(","),
        desc: configuration.groups[o.group].label,
      } : { value: o.value, desc: o.desc });
      Object.defineProperty(field.dati, "configured", { value: true });
    }
    return [key, field];
  }));
  const resolve = node => {
    if (Array.isArray(node)) return node.map(resolve);
    if (node.field) return fields[node.field];
    return { ...node, ...(node.campi ? { campi: node.campi.map(resolve) } : {}) };
  };
  return {
    datiTendineOrdine: catalogs, tuttiIcampiRicerca: fields,
    selezioneCampiRicerca: Object.fromEntries(Object.entries(configuration.views).map(([key, view]) => [key, resolve(view)])),
    groups: configuration.groups,
  };
}
export function configDifferences(before, after) {
  return ["catalogs", "groups", "fields", "views"].flatMap(section => Object.keys(after[section]).filter(key => JSON.stringify(before[section][key]) !== JSON.stringify(after[section][key])).map(key => ({ section, key })));
}
export function expandDepartureGroup(input, groups) {
  const value = input?.["sped.Partenza_da ="];
  const key = value === "Vernante (tutti)" || value === "Vernante + Marro" ? "vernanteMarro" : value === "Vernante (tutto BOT)" ? "vernanteBot" : null;
  if (!key) return input;
  const result = { ...input, "sped.Partenza_da IN": groups[key].members.slice() };
  delete result["sped.Partenza_da ="];
  return result;
}
